module.exports = __webpack_public_path__ + "static/media/artwork-upload.3d735188.gif";